import { isSharedStation } from '@app/core/stations/helpers';
import PublicIcon from '@mui/icons-material/Public';
import { Box, Tooltip } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { useIntl } from 'react-intl';
import {
  STATION_INDICATOR_BADGE_ICON_FONT_SIZE,
  StationIndicatorBadge,
  StationIndicatorBadgeSize,
} from './StationIndicatorBadge';
import { sharedStationTooltipMessage } from './station-messages';
import { MinimumStation, Station } from '@app/core/types/stations';

type SharedStationIconSize = StationIndicatorBadgeSize;

interface SharedStationIconProps {
  station?: Station | MinimumStation | null;
  size?: SharedStationIconSize;
  sx?: SxProps<Theme>;
  iconSx?: SxProps<Theme>;
}

/**
 * Renders a shared-station indicator icon when the station has SHARED access type.
 */
export function SharedStationIcon({
  station,
  size = 'medium',
  sx,
  iconSx,
}: SharedStationIconProps) {
  const { $t } = useIntl();

  if (!station || !('accessType' in station) || !isSharedStation(station as Station)) {
    return null;
  }

  return (
    <Tooltip title={$t(sharedStationTooltipMessage)}>
      <Box component="span" display="inline-flex" alignItems="center">
        <StationIndicatorBadge size={size} sx={sx}>
          <PublicIcon
            sx={
              [
                {
                  fontSize: STATION_INDICATOR_BADGE_ICON_FONT_SIZE[size],
                  color: 'text.secondary',
                },
                iconSx,
              ] as SxProps<Theme>
            }
          />
        </StationIndicatorBadge>
      </Box>
    </Tooltip>
  );
}
